




































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import FeedbackService from "../../services/feedbacks";
import { Feedback } from "@/services/feedbacks/feedbacks.types";

@Component
export default class Feedbacks extends Vue {
  mounted() {
    this.getFeedbacks();
  }

  get getLoading() {
    return Object.values(this.indicators).filter(v => !!v).length > 0;
  }

  filters: { app: string; startDate: number; endDate: number } = {
    app: "coobrick",
    startDate: 0,
    endDate: 0
  };

  qs: { id: string; created_at: number } = {
    id: "",
    // eslint-disable-next-line @typescript-eslint/camelcase
    created_at: 0
  };
  selected = [];
  endDate = new Date().toISOString().substr(0, 10);
  startDate = new Date(
    new Date().getFullYear(),
    new Date().getMonth() - 1,
    new Date().getDate()
  )
    .toISOString()
    .substr(0, 10);
  menu1 = false;
  modal = false;
  menu2 = false;
  feedbacks: (Feedback & { toHandle: boolean })[] = [];
  lastKey = {};
  error: Error;
  indicators = {
    updatingFeedbacks: false
  };
  apps = [
    "scanner",
    "sudoku",
    "translator",
    "cleaner",
    "coobrick",
    "lap",
    "scanner2",
    "gen.atom.scanguru.paid",
    "com.lopofist.scanner",
    "recorder"
  ];

  // data() {
  //   return {
  //     // selected: [],
  //     apps: ["scanner", "sudoku", "translator", "cleaner", "coobrick", "lap"],
  //     endDate: new Date().toISOString().substr(0, 10),
  //     startDate: new Date(
  //       new Date().getFullYear(),
  //       new Date().getMonth() - 1,
  //       new Date().getDate()
  //     )
  //       .toISOString()
  //       .substr(0, 10),
  //     menu1: false,
  //     modal: false,
  //     menu2: false
  //   };
  // }

  @Watch("filters", { deep: true })
  async getFeedbacks() {
    this.filters.startDate = Math.round(+new Date(this.startDate));
    this.filters.endDate =
      Math.round(+new Date(this.endDate)) + 1000 * 60 * 60 * 24;
    this.indicators["updatingFeedbacks"] = true;
    const filters = Object.entries(this.filters)
      .filter(([v]) => !!v.length)
      .reduce((acc, [n, v]) => ({ ...acc, [n]: v }), {});

    return FeedbackService.getFeedbacks(
      process.env.VUE_APP_FEEDBACKS_URL_PROD,
      filters
    )
      .then(list => {
        list.feedbacks.forEach(
          (el: any) =>
            // eslint-disable-next-line @typescript-eslint/camelcase
            (el.created_at = new Date(el.created_at).toUTCString())
        );
        this.feedbacks = list.feedbacks;
        this.qs.id = decodeURIComponent(list.LastEvaluatedKey.id);
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.qs.created_at = list.LastEvaluatedKey.created_at;
      })
      .catch((e: Error) => (this.error = e))
      .finally(() => (this.indicators["updatingFeedbacks"] = false));
  }

  async loadMore() {
    this.indicators["updatingFeedbacks"] = true;
    // eslint-disable-next-line @typescript-eslint/camelcase
    this.qs = {
      ...this.filters,
      id: this.qs.id,
      // eslint-disable-next-line @typescript-eslint/camelcase
      created_at: this.qs.created_at
    };
    return FeedbackService.getFeedbacks(
      process.env.VUE_APP_FEEDBACKS_URL_PROD,
      this.qs
    )
      .then(list => {
        list.feedbacks.forEach(
          (el: any) =>
            // eslint-disable-next-line @typescript-eslint/camelcase
            (el.created_at = new Date(el.created_at).toUTCString())
        );
        if (!list.LastEvaluatedKey) return;
        this.feedbacks = [...this.feedbacks, ...list.feedbacks];
        this.qs.id = decodeURIComponent(list.LastEvaluatedKey.id);
        // eslint-disable-next-line @typescript-eslint/camelcase
        this.qs.created_at = list.LastEvaluatedKey.created_at;
      })
      .catch((e: Error) => (this.error = e))
      .finally(() => (this.indicators["updatingFeedbacks"] = false));
  }

  async putFeedbacks() {
    this.indicators["updatingFeedbacks"] = true;
    // eslint-disable-next-line @typescript-eslint/camelcase
    // await this.selected.map((obj: { handled: boolean; created_at: any }) => {
    //   (obj.handled = true),
    //     // eslint-disable-next-line @typescript-eslint/camelcase
    //     (obj.created_at = Date.parse(obj.created_at));
    // });
    await FeedbackService.putFeedbacks(
      process.env.VUE_APP_FEEDBACKS_URL_PROD,
      this.feedbacks
        .filter(({ toHandle }) => toHandle)
        .map(feedback => ({
          ...feedback,
          handled: feedback.toHandle
        }))
    );
    await this.getFeedbacks();
    this.selected = [];
  }

  headers = [
    { text: "id", value: "id", sortable: false },
    { text: "App", value: "app", sortable: false },
    { text: "Email", value: "mail", sortable: false },
    { text: "Message", value: "text", sortable: false },
    { text: "Creation time", value: "created_at" },
    { text: "Handled", value: "handled", sortable: false }
  ];
}
